<!--
/*******************************************************************************
*@ 컴포넌트명   : Product1101002000012ogcbd.vue
*@ 컴포넌트설명 :[캄보디아] 예금 상품 > 예금 상품 상세(개인보통예금)
*@ 사용전문     :
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 2021.10.13   주형진  
********************************************************************************/
-->
<template>
  <section class="deposit detail">
    <!--한국어-->
    <template v-if="lang == $config.LANG_KOR">
      <div class="scroll">
        <article class="content-header bg-type">
          <div class="title">
            <h2>개인보통예금</h2>
          </div>
          <div class="description">
            <p>
              일시적 여유자금 보관목적의 입금 및 출금이 자유로운 예금
            </p>
          </div>
          <!-- 금리 이율 있을 경우 -->
          <div v-if="true" class="summary">
            <div class="item item-row">
              <div class="tit">
                <span class="exchange-unit">USD</span>
                <span class="text">연 </span>
              </div>
              <div class="percent">
                0.50%
              </div>
            </div>
            <div class="item item-row">
              <div class="tit">
                <span class="exchange-unit">KHR</span>
                <span class="text">연 </span>
              </div>
              <div class="percent">
                0.70%
              </div>
            </div>
          </div>
          <!--// 금리 이율 있을 경우 end -->
        </article>
        <article class="contents">
          <dl class="dlist dlist-item--type5">
            <dt>상품유형</dt>
            <dd>보통예금</dd>
            <dt>상품개요</dt>
            <dd>일시적 여유자금 보관목적의 입금 및 출금이 자유로운 예금</dd>
            <dt>가입대상</dt>
            <dd>18세 이상 성인</dd>
            <dt>계약기간</dt>
            <dd>제한없음</dd>
            <dt>가입통화</dt>
            <dd>USD, KHR</dd>
            <dt>가입금액</dt>
            <dd>신규가입 시 최저 USD 100.00 이상</dd>
            <dt>금리 및 이율</dt>
            <dd>
              USD : 약정이율 연 0.50%<br />
              KHR : 약정이율 연 0.70%
            </dd>
            <dt>수수료</dt>
            <dd>해당무</dd>
            <dt>가입방법</dt>
            <dd>영업점가입</dd>
            <dt>가입시 필요서류</dt>
            <dd>ID 카드, 여권 등 실명확인증표</dd>
          </dl>
        </article>
      </div>
    </template>

    <!--영어-->
    <template v-else-if="lang == $config.LANG_ENG">
      <div class="scroll">
        <article class="content-header bg-type">
          <div class="title">
            <h2>Personal Current Account</h2>
          </div>
          <div class="description">
            <p>
              Savings that can deposit and withdraw money freely for an archival purpose of a temporary surplus funds
            </p>
          </div>
          <!-- 금리 이율 있을 경우 -->
          <div v-if="true" class="summary">
            <div class="item">
              <div class="tit">
                <span class="exchange-unit">USD</span>
              </div>
              <div class="percent">
                0.50% annually
              </div>
            </div>
            <div class="item">
              <div class="tit">
                <span class="exchange-unit">KHR</span>
              </div>
              <div class="percent">
                0.70% annually
              </div>
            </div>
          </div>
          <!--// 금리 이율 있을 경우 end -->
        </article>
        <article class="contents">
          <dl class="dlist dlist-item--type5">
            <dt>Types</dt>
            <dd>Current Account</dd>
            <dt>About the products</dt>
            <dd>Savings that can deposit and withdraw money freely for an archival purpose of a temporary surplus funds</dd>
            <dt>Eligibilty</dt>
            <dd>Adults over 18 years old</dd>
            <dt>Contract Terms</dt>
            <dd>No restrictions</dd>
            <dt>Available currency</dt>
            <dd>USD, KHR</dd>
            <dt>Deposit amount</dt>
            <dd>To open a new account, minimum USD 100.00 deposit amount is required.</dd>
            <dt>Rates</dt>
            <dd>
              USD : Agreed interest rate of 0.50% annually<br />
              KHR : Agreed interest rate of 0.70% annually
            </dd>
            <dt>Fees</dt>
            <dd>N/A</dd>
            <dt>How to apply</dt>
            <dd>Apply at the branch</dd>
            <dt>Required documents for application</dt>
            <dd>ID card, passport, identity verification, etc.</dd>
          </dl>
        </article>
      </div>
    </template>

    <!--캄포디아어-->
    <template v-else>
      <div class="scroll">
        <article class="content-header bg-type">
          <div class="title">
            <h2>ការសន្សំប្រាក់រយៈពេលខ្លីសំរាប់និវាសជន</h2>
          </div>
          <div class="description">
            <p>
              បញ្ចូលទឹកប្រាក់ធម្មតាដែលអាចរក្សាប្រាក់ទុកក្នុងធនាគារហើយអាច បញ្ចុលប្រាក់និងដកប្រាក់បាន។
            </p>
          </div>
          <!-- 금리 이율 있을 경우 -->
          <div v-if="true" class="summary">
            <div class="item item-row">
              <div class="tit">
                <span class="exchange-unit">USD</span>
                <span class="text">ក្នុងកិច្ចសន្យា ការប្រាក់ក្នុងមួយឆ្នាំ</span>
              </div>
              <div class="percent">
                0.50%
              </div>
            </div>
            <div class="item item-row">
              <div class="tit">
                <span class="exchange-unit">KHR</span>
                <span class="text">ក្នុងកិច្ចសន្យា ការប្រាក់ក្នុងមួយឆ្នាំ</span>
              </div>
              <div class="percent">
                0.70%
              </div>
            </div>
          </div>
          <!--// 금리 이율 있을 경우 end -->
        </article>
        <article class="contents">
          <dl class="dlist dlist-item--type5">
            <dt>ប្រភេទផលិតផល</dt>
            <dd>បា្រក់បញ្ញើធម្មតា</dd>
            <dt>មាតិកាផលិតផល</dt>
            <dd>បញ្ចូលទឹកប្រាក់ធម្មតាដែលអាចរក្សាប្រាក់ទុកក្នុងធនាគារហើយអាច បញ្ចុលប្រាក់និងដកប្រាក់បាន។</dd>
            <dt>អតិថិជនគោលដៅ</dt>
            <dd>អ្នកដែលមានអាយុចាប់ពី១៨ឆ្នាំឡើងទៅ</dd>
            <dt>រយៈពេលកិច្ចសន្យា</dt>
            <dd>មិនមានកំនត់</dd>
            <dt>ប្រភេទរូបិយប័ណ្ណដែលស្នើសុំ</dt>
            <dd>USD, KHR</dd>
            <dt>ចំនួនទឹកប្រាក់ដែលស្នើសុំ</dt>
            <dd>ចំនួនទឹកប្រាក់ដំបូងតិចបំផុត USD100.00</dd>
            <dt>អត្រាការប្រាក់</dt>
            <dd>
              USD : ក្នុងកិច្ចសន្យា ការប្រាក់ក្នុងមួយឆ្នាំ0.50%<br />
              KHR : ក្នុងកិច្ចសន្យា ការប្រាក់ក្នុងមួយឆ្នាំ0.70%
            </dd>
            <dt>កំរៃសេវា</dt>
            <dd>គ្មាន</dd>
            <dt>របៀបចុះឈ្មោះ</dt>
            <dd>ចុះឈ្មោះនៅសាខា</dd>
            <dt>តំរូវការឯកសារចុះឈ្មោះ</dt>
            <dd>កាតID លិខិតឆ្លងដែន និងលេខអត្តសញ្ញាណប័ណ្ណ</dd>
          </dl>
        </article>
      </div>
    </template>
  </section>
</template>
<script>
import { mapFields } from "vuex-map-fields";
export default {
  computed: {
    ...mapFields(["lang"]),
  },
};
</script>
